const links = [...document.querySelectorAll('a[href^="https://' + location.hostname + '"],a[href^="http://' + location.hostname + '"],a[href^="#"],a[href^="/"]')]


if (links.length) {
    links.forEach(function appendQueryParams (el) {
        var query = '';
        var linkHref = el.getAttribute('href');
        var linkHash = '';

        // if loop link has a hash, get it and store it to append to end after query params
        if (el.getAttribute('href').indexOf("#") != -1) {
            let linkParts = el.getAttribute('href').split('#');
            linkHref = linkParts[0];
            if (typeof linkParts[1] !== 'undefined') {
                linkHash = '#' + linkParts[1];
            }
        }
        // check if current url has a hash, if so try to get query params from there if they exist
        if (location.hash) {
            var hashSplit = location.hash.split('?');
            if (typeof hashSplit[1] !== 'undefined') {
                var hash = hashSplit[0];
                query = '?' + hashSplit[1];
                el.setAttribute('href', linkHref + query + linkHash);
            }
        }
        // otherwise, use location.search for query params
        if (!query) {
            el.setAttribute('href', linkHref + location.search + linkHash);
        }
    })
}